export default __webpack_public_path__ + "static/media/go-beyond.f241a6ab.jpeg";